import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import useElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeter'
import { FormControl } from 'baseui/form-control'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { getAuthorizationText } from '@/shared/utils/meterAuthorizationUtils'

const EnedisAuth = () => {
  const { t, canRequestMeterData, isValidPdl, enedisAuth, handleAuthorizationClick } = useElectricityMeter({
    type: 'client',
  })

  if (!canRequestMeterData) {
    return null
  }

  const primaryText = getAuthorizationText(t, 'cdf', 'elec')

  // todo-v2: review if we can convert it to a normal button
  return (
    <SDNotification type='info' hidden={enedisAuth} primaryText={primaryText}>
      <FormControl
        overrides={{
          ControlContainer: {
            style: () => ({
              marginBottom: 0,
              marginTop: '.5rem',
            }),
          },
        }}
      >
        <SDButtonGroup
          disabledOptions={(() => {
            if (enedisAuth || !isValidPdl || !canRequestMeterData) {
              return ['true', 'false']
            }

            if (
              canRequestMeterData ||
              isValidPdl
              // && isEditable === true TODO: isEditable undefined, pending to implement
            ) {
              return []
            }

            return ['true', 'false']
          })()}
          onClickHandler={handleAuthorizationClick}
          options={[{ true: t('subscriptionForm:pdl_module.enedis_authorization.authorize_yes') }]}
          selectedValue={enedisAuth ? enedisAuth?.toString() : 'false'}
        />
      </FormControl>
    </SDNotification>
  )
}

export default EnedisAuth
